<template>
    <div class="itemlist" :class="[root.device=='phone'&&'notransform']">
        <van-row type='flex' class="columns" :style="{'background':columnbg,'height':(root.device=='phone'&&'40px')}">
            <van-col :style="setCss(item)" class="colname" v-for="(item,index) in columns" :key="index">
              <span v-if="!columns[index].slot_head"> {{item.title}} </span>         
              <item-slot  v-if="columns[index].slot_head"  :data="item" :slotname="columns[index].slot_head"></item-slot>              
            </van-col>
        </van-row>
            <van-row   class="datarow" :style="{height:dheight}" :class="[{'active':i==Math.ceil(count/2)-1}]" type='flex' v-for="(item,i) in viewdata" :key="i" >  
            <van-col  class="datarow_cell" :style="setCss(columns[index])" v-for="(key,index) in columns" :key="index"  > 
                   <span v-if="viewdata.length>1">
                        <span v-if="!columns[index].slot">
                <span v-if="key['title']==='支付金额'||key['title']==='退款总金额'
                ||key['title']==='销售金额'||key['title']==='销售额'"> 
                  {{"" !=item[key['key']] && item[key['key']]!=null&&item[key['key']]!=undefined?$toThousands(item[key['key']].toFixed(2)):''}}
                    </span>
                <span v-else> 
                    {{key['format']?key['format'](item[key['key']]):item[key['key']]}}
                    </span>         
                </span>     
                <item-slot  v-if="columns[index].slot"  :data="item" :slotname="columns[index].slot"></item-slot> 
                   </span>
            </van-col>
        </van-row>
    </div>
</template>
<script>
import ItemSlot from "@/components/cuscom/slot.js"
export default {    
    props:{
        columns:Array,
        data:Array,
        count:Number,
        dheight:String,
        columnbg:String
    },     
    components:{
        ItemSlot
    },
    inject:['root'],
    provide () {
        return {
            listRoot: this
        };
     },
    data(){
        return {     
            timer:false, 
            viewdata:[]    
        }
    },
    computed:{
        keys(){                  
           return this.setKeys();
        }
    },    
    watch:{
        data:{
            handler(){    
                
            //    this.viewdata=this.data.slice(0,this.count)    
            //    this.doit()
            this.init()
            },
            deep:false
        }
    },
    methods:{
        init(){
            this.viewdata=this.data.slice(0,this.count)    
            this.doit()
        },
        //动画
        doit(){    
            if(this.timer){
                window.clearTimeout(this.timer);
            }
            this.timer= setTimeout(()=>{             
                this.runData()
            },3000)       
        },
        //滚动展示数据计算
        runData(){                   
             this.data.push(this.data.shift());           
        },
        //设置cell样式
        setCss(item){
          let styleObject={}        
          item.type&&(styleObject["display"]=item.type);
          item.justify&&(styleObject["justifyContent"]=item.justify);
          item.align&&(styleObject["alignItems"]=item.align,styleObject["textAlign"]=item.align);          
          item.width?styleObject["width"]=item.width:(styleObject["flex"]=item.flex||1);
          //styleObject["background"]="red"
          return styleObject;
        },                
        //获取key顺序
        setKeys(columns){
           const keys=this.columns.map(item=>{          
              return item.key                   
           })  
           return keys
        }
    },
    mounted(){
    //  this.init()
    }
}
</script>
<style lang="scss" scoped>
   .itemlist{
       
           display: flex;
            flex-direction: column;
            height: 100%;
        .columns{
            height: 50px;
            background-color: rgba(0,0,0,0.6);
            align-items: center;
        }
        .datarow{
              align-items: center;
             
              color:#fff;
              font-size: 15px;
              flex:1;
              &.active{
                  color:#eacd2c;
                  font-size: 17px;
              }
              .datarow_cell{
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
              }
        }
        &.notransform{
          .colname{           
           font-size:13px  !important;
          }
          .datarow{
              font-size: 13px !important;
              &.active{
                font-size: 18px !important;
              }
          }
        }
       .colname{
           color:#fff;
           font-size:15px;
       }
   }
</style>